export default "__VITE_ASSET__YdAP31hW__"